import { render, staticRenderFns } from "./MdtButton.vue?vue&type=template&id=6d0f99ab&scoped=true"
import script from "./MdtButton.vue?vue&type=script&lang=js"
export * from "./MdtButton.vue?vue&type=script&lang=js"
import style0 from "./MdtButton.vue?vue&type=style&index=0&id=6d0f99ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f99ab",
  null
  
)

export default component.exports